/**
 * Registro y gestión del Service Worker para PWA
 */

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

/**
 * Registra el service worker y configura la detección de actualizaciones
 */
export function register() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/sw.js', {
                    // Forzar comprobación de actualizaciones en cada carga
                    updateViaCache: 'none'
                })
                .then((registration) => {
                    console.log('Service Worker registrado');

                    // Función para manejar la detección de actualizaciones
                    const checkForUpdates = () => {
                        registration.update().then(() => {
                            console.log('Comprobación de actualización realizada');
                        });
                    };

                    // Comprobar al abrir
                    setTimeout(() => {
                        console.log('Comprobando actualizaciones al abrir...');
                        checkForUpdates();
                    }, 5000);

                    // Luego comprobar cada 60 segundos
                    setInterval(checkForUpdates, 60000);

                    // Detectar cuando hay un nuevo service worker esperando
                    registration.addEventListener('updatefound', () => {
                        const newWorker = registration.installing;
                        console.log('Nueva versión del Service Worker encontrada');

                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                // Hay una nueva versión disponible
                                console.log('Nueva versión lista. Notificando al usuario...');

                                // Emitir evento para que el componente UpdateNotification lo maneje
                                window.dispatchEvent(new CustomEvent('sw-update-available', {
                                    detail: { registration }
                                }));
                            }
                        });
                    });

                    // IMPORTANTE: Si ya hay un SW esperando, notificar inmediatamente
                    if (registration.waiting) {
                        console.log('Ya hay una actualización esperando. Notificando...');
                        window.dispatchEvent(new CustomEvent('sw-update-available', {
                            detail: { registration }
                        }));
                    }
                })
                .catch((error) => {
                    console.error('Error al registrar Service Worker:', error);
                });
        });
    }
}

/**
 * Desregistra el service worker
 */
export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}
